<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
          <el-form
            :inline="true"
            :model="searchForm"
            :rules="searchRules"
            ref="searchForRef"
            label-width="80px"
            autocomplete="on"
            size="mini"
          >
            <el-form-item label="订单编号">
              <el-input v-model="searchForm.order_sn" placeholder="请输入订单编号" clearable type="text"></el-input>
            </el-form-item>

            <el-form-item label="收货人">
              <el-input v-model="searchForm.consignee" placeholder="请输入收货人姓名" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item label="收货电话">
              <el-input v-model="searchForm.tel" placeholder="请输入收货人电话" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item label="收货地址">
              <el-input v-model="searchForm.address" placeholder="请输入收货地址" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item label="下单日期">
              <el-date-picker
                v-model="searchForm.start_end_date"
                type="daterange"
                align="right"
                size="mini"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="startEndOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-select
                v-model="searchForm.order_status"
                style="width: 180px;"
                clearable
                placeholder="请选择订单状态"
              >
                <el-option
                  v-for="item in orderStatusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">

                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付状态">
              <el-select
                v-model="searchForm.pay_status"
                style="width: 180px;"
                placeholder="请选择订单状态"
                clearable
              >
                <el-option
                  v-for="item in payStatusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">

                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="success" size="mini" @click="searchSubmit()">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="info"  @click="goExcel()"><i class="el-icon-download"></i>导出</el-button>
            </el-form-item>
          </el-form>
      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        stripe
        border
        size="mini"
      >
        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>
        <el-table-column
          label="用户昵称"
          width="120"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.user? scope.row.user.nickname:'' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="用户手机号"
          width="120"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.user? scope.row.user.user_name:'' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="订单编号"
          width="180"
          prop="order_sn"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="订单金额"
          width="120"
          prop="order_amount"
        >
        </el-table-column>
        <el-table-column
          label="下单日期"
          width="130"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.add_time | dateFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="支付方式"
          show-overflow-tooltip
          width="80"
        >
          <template slot-scope="scope">
            {{scope.row.pay_id==6?"微信":scope.row.pay_name}}
          </template>
        </el-table-column>
        <el-table-column
          label="支付时间"
          show-overflow-tooltip
          width="80"
        >
          <template slot-scope="scope">
            {{scope.row.pay_time!=null?parseDateFull(scope.row.pay_time*1000):''}}
          </template>
        </el-table-column>
        <el-table-column
          label="收货人"
          show-overflow-tooltip
          width="80"
        >
          <template slot-scope="scope">
            {{scope.row.consignee}}
          </template>
        </el-table-column>

        <el-table-column
          label="收货电话"
          show-overflow-tooltip
          width="80"
        >
          <template slot-scope="scope">
            {{scope.row.tel}}
          </template>
        </el-table-column>
        <el-table-column
          label="收货地址"
          show-overflow-tooltip
          width="80"
        >
          <template slot-scope="scope">
            {{scope.row.address}}

          </template>
        </el-table-column>
        <el-table-column
          width="200"
          label="交易状态">
          <template slot-scope="scope">
            <p v-if="scope.row.pay_status==2">
                            <span>
                            <el-tag size="small"  type="success"  >已支付</el-tag>
                            </span>
            </p>
            <p v-if="scope.row.shipping_status==1">

                            <span>
                                  <el-tag size="small"  type="success"  >已发货</el-tag>
                            </span>
            </p>
            <p v-if="scope.row.shipping_status==2" >
                            <span>
                                <el-tag size="small"  type="success" >已收货</el-tag>
                        </span></p>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100">
          <template slot-scope="scope">
            <el-button @click="goInfo(scope.row)"  type="text" size="mini">详情</el-button>
            <el-button @click="goPrint(scope.row)"  type="text" size="mini">溯源</el-button>
          </template>
        </el-table-column>

      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">

        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" autocomplete="off" placeholder="请输入名称"></el-input>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import * as XLSX from 'xlsx/xlsx.mjs';
  import { saveAs } from 'file-saver';


  import moment from 'moment'     //日期时间转换

  export default {
    name: "orderList",
    components: {
    },
    props: {},
    data() {
      return {
        // 搜索
        searchForm: {
          consignee: "",
          order_sn:'',
          address:'',
          tel:'',
          start_end_date:'',
          pay_status:2,
          order_status:''
        },
        payStatusList:[
          {id:0,name:'待付款'},{id:2,name:'已支付'}

        ],
        shippingStatusList:[
          {id:0,name:'待发货'},{id:1,name:'已发货'},{id:2,name:'已收货'}
        ],
        orderStatusList:[
          {id:0,name:'待处理'},{id:2,name:'订单关闭'},{id:6,name:'待评价 '},{id:7,name:'已完成 '}
        ],
        searchRules: {
          name: [
            { required: true, message: "请输入名称", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入保司名称', trigger: 'blur' },
            {
              min: 3,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],

        },
        startEndOptions:{
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        dialogFormVisible: false,
        title: '',
        form: {
          name: '',
        },

      };
    },
    created() {

      this.DataList()
      this.departData()
    },
    mounted() {
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      statusFilter(status) {
        if (status == 0) {
          return "待审核";
        } else if (status == 1) {
          return "已审核";
        } else if (status == 2) {
          return "已出单";
        } else if (status == 3) {
          return "已完成";
        } else if (status == 4) {
          return "取保";
        } else if (status == 5) {
          return "退单";
        }
      },

    },
    methods: {
      goPrint(row){
        this.$router.push({
          path:'/orderPrint',
          query:{
            id:row.order_id
          }
        })
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      goExcel(){
// 假设你有一个表格的数据
        const data = [
          ["编号", "订单编号", "订单状态","下单时间", "支付时间", "发货时间", "下单通道", "买家备注", "支付方式",'订单金额(含运费)'
            ,'电子抵扣','e福礼抵扣','电子券活动名称','e福礼活动名称','积分抵扣','订单支付现金','用户ID','用户名'
            ,'收货人姓名','省市','地址','手机号码','邮编','商品类型','商品编号','商品SKU编号','商品名称'
            ,'商品单价','购买数量','商品金额','退款单编号','物流公司名称','物流发货单号','配送类型','发货时间','配送日期']
        ];

        // 将数据转换为工作表
        const worksheet = XLSX.utils.aoa_to_sheet(data);

        // 创建工作簿并添加工作表
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // 生成Excel文件
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        // 使用blob和FileReader创建一个Blob URL
        const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
        const blobUrl = window.URL.createObjectURL(dataBlob);

        // 使用filesaver.js保存文件
        saveAs(dataBlob, 'export.xlsx');
        // 清理
        window.URL.revokeObjectURL(blobUrl);
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          shop_id:sessionStorage.getItem('shop_id'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }

        if(this.searchForm.consignee){
          param.consignee=this.searchForm.consignee;
        }
        if(this.searchForm.address){
          param.address=this.searchForm.address;
        }
        if(this.searchForm.tel){
          param.tel=this.searchForm.tel;
        }
        if(!isNaN(this.searchForm.pay_status)){
          param.pay_status=this.searchForm.pay_status;
        }
        if(!isNaN(this.searchForm.order_status)){
          param.order_status=this.searchForm.order_status;
        }
        if(this.searchForm.start_end_date){
          const [start_date,end_date]=this.searchForm.start_end_date;
          param.start_time=start_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+start_date.getDate();
          param.end_time=end_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+end_date.getDate();
        }
        this.$axios.shippingOrderinfoList(param).then(res=>{
          if(res.code == 200){
            console.log(res,1111);
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      goInfo(row){

        this.$router.push({
          path:'/shopOrderInfo',
          query:{
            id:row.order_id
          }
        })
      },
      handelEdit(index,row) {
        console.log(row)
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },
      searchSubmit() {
        this.pageNum=1;
        this.DataList();
      },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },
      parseDateFull(time) {
        var x = new Date(time);
        var z = {
          y: x.getFullYear(),
          M: x.getMonth() + 1,
          d: x.getDate(),
          h: x.getHours(),
          m: x.getMinutes(),
          s: x.getSeconds(),
        };
        if (z.M < 10) {
          z.M = "0" + z.M;
        }
        if (z.d < 10) {
          z.d = "0" + z.d;
        }
        if (z.h < 10) {
          z.h = "0" + z.h;
        }
        if (z.m < 10) {
          z.m = "0" + z.m;
        }
        return z.y + "-" + z.M + "-" + z.d + " " + z.h + ":" + z.m ;
        // return  z.h + ":" + z.m ;
      },

    },
  };
</script>
<style>

</style>
